import { IconButton, Tooltip } from '@mui/material';

import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import Iconify from 'src/components/iconify';

/*
  The Send icon at the end of a customer row - the compose window for that row's customer,
  without opening the customer first.

  The column carries no heading (label: ''), so the icon has to say what it is on its own: hence
  the tooltip and the aria-label, which is also what a screen reader reads in place of the missing
  column name.
*/
export default function RenderSendMessage({
  row,
  onClick,
}: ICasRenderCellProps & { onClick: (entityId: number) => void }) {
  return (
    <Tooltip title="Send a message">
      <IconButton size="small" aria-label="Send a message" onClick={() => onClick(row.id)}>
        <Iconify icon="ic:outline-message" />
      </IconButton>
    </Tooltip>
  );
}

/* The column itself, so the Customers and Touchpoints listings cannot drift apart. */
export const sendMessageColumn = (onClick: (entityId: number) => void) => ({
  field: 'sendMessage',
  label: '',
  sortable: false,
  align: 'center' as const,
  render: (props: ICasRenderCellProps) => <RenderSendMessage {...props} onClick={onClick} />,
});
